// extracted by mini-css-extract-plugin
export default {"text":"ProgressBar_text__X+XMl","progressBar":"ProgressBar_progressBar__X-J7p","progress":"ProgressBar_progress__AkEqP"};